export default class NullablePrimitive {
    constructor(value, transform = (value) => value) {
        this.value = value;
        this.transform = transform;
    }
    get() {
        return this.value ? this.transform(this.value) : null;
    }
}
